import {
  DedicatedTopUpAccounts,
  QuickTable,
  QuickTableFilterTabs,
  SwitchAppButton,
} from "../../components";
import { CreateTopUpForm } from "./CreateTopUpForm";
import { topUpsDisplayFormatter } from "./topUpsDisplayFormatter";
import { Link, Route, Routes } from "react-router-dom";

import { ITopUpViewProps } from "./TopUps";
import { Add, ViewFilled } from "@carbon/icons-react";

export const View = (props: ITopUpViewProps) => {
  return (
    <Routes>
      <Route
        index
        element={
          <>
            <DedicatedTopUpAccounts />

            <QuickTable
              id="topUpsTable"
              data={props.data}
              headers={props.headers}
              isLoading={props.isLoading}
              isError={props.isError}
              itemCount={props.totalCount}
              renderDetail={(item) => item.description}
              toolbarTabs={
                <QuickTableFilterTabs
                  queryStringTabNavLinks={props.queryStringTabs}
                />
              }
              displayFormatter={topUpsDisplayFormatter}
              onExport={props.onExport}
              openCreateNewModal={props.openCreateNewModal}
              createNewButtonText="New Top-Up"
              // openDetailsModal={props.openDetailsModal}
              extraButtons={
                <>
                  {/* <Link to="/balances" className="switchapp-link">
                        View Balance
                      </Link> */}
                  <SwitchAppButton
                    onClick={props.navigateToViewBalance}
                    size="sm"
                    kind="success"
                    className="switchapp-themed create-new-button"
                  >
                    <ViewFilled size={20} className="mr-5" />
                    View Balance
                  </SwitchAppButton>
                </>
              }
            />
          </>
        }
      />
      <Route
        path="create"
        element={
          <CreateTopUpForm
            refreshTable={props.refreshTable}
            goBackOnClose={false}
          />
        }
      />
      {/* <Route path=":id/details" element={<TopUpDetailsModal />} /> */}
    </Routes>
  );
};
